const getQueryParamsAsString = (): string => {
  if (typeof window !== 'undefined') {
    const queryParams = window.location.search;
    return queryParams;
  }
  return '';
};

export default getQueryParamsAsString;
